import React from 'react';
import {Box} from "@mui/material"
import {alpha} from "@mui/material/styles"
import {classColor} from "../../library/ClassColors"

interface ClassChipProps {
    value: string
    color?: string
}

function ClassChip({value, color}: ClassChipProps) {
    if (!value) {
        return <Box component="span" sx={{color: "text.disabled"}}>—</Box>
    }

    const resolved = color ?? classColor(value)
    return (
        <Box component="span"
             title={value}
             sx={{
                 display: "inline-block",
                 maxWidth: "100%",
                 px: 0.75,
                 py: 0.25,
                 borderRadius: 1,
                 fontSize: "0.8125rem",
                 fontWeight: 600,
                 lineHeight: 1.5,
                 whiteSpace: "nowrap",
                 overflow: "hidden",
                 textOverflow: "ellipsis",
                 verticalAlign: "middle",
                 color: resolved,
                 bgcolor: alpha(resolved, 0.14),
             }}>
            {value}
        </Box>
    )
}

export default ClassChip;
